module.exports = __webpack_public_path__ + "img/refresh-icon.514788f2.svg";